module.exports = __webpack_public_path__ + "static/media/4-3.ebe6de94.mp3";